// Module
var code = `<div class="subcategories">
    <div class="block-heading subcategories-heading">
        Categorieën:
    </div>
    <ul style="list-style-type: none;" data-bind="template: { name: 'node', foreach: categoryTree }" id="subcategories-tree" class="subcategories-tree level1"></ul>
</div>

${"<" + "script"} type="text/html" id="node">
    <li class="tree-item facet-filter-category-option">
        <!-- ko if: categories.length > 0 -->
        <label data-bind="attr: { for: \`category-tree-input-\${id}\` }">
            <span data-bind="text: name" class="subcategory-title"></span>
            <span data-bind="text: \`(\${count()})\`" class="filter-count">()</span>
            <input data-bind="value: id, attr: {id: \`category-tree-input-\${id}\`}, checked: \$data.checked, event: {change: \$root.handleSubmit}" class="hidden" type="checkbox" />
        </label>
        <span data-bind="click: toggleState, css: {'tree-arrow-collapse': open}" class="tree-arrow"></span>
        <ul data-bind="template: { name: 'node', foreach: categories }, css: {'visible': open(), level2: level == 1, level3: level == 2}" style="list-style-type: none" class="nested subcategories-tree" ></ul>
        <!-- /ko -->

        <!-- ko if: categories.length === 0 -->
        <label data-bind="attr: { for: \`category-tree-input-\${id}\` }, css: {'active': checked}" class="">
            <span data-bind="text: name" class="subcategory-title"></span>
            <span data-bind="text: \`(\${count()})\`" class="filter-count">()</span>
            <input data-bind="value: id, attr: {id: \`category-tree-input-\${id}\`}, checked: \$data.checked,  event: {change: \$root.handleSubmit}" class="hidden" type="checkbox">
        </label>
        <!-- /ko -->
    </li>
${"<" + "/script"}>
`;
// Exports
module.exports = code;